import React, { lazy } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import ProductDetailsScreen from '../../screens/ProductDetailsScreen';
import parentPaths from '../paths';

const DashboardScreen = lazy(() => import('../../screens/DashboardScreen'));
const ProductsScreen = lazy(() => import('../../screens/ProductsScreen'));
const AutoFulfillmentDetails = lazy(() => import('../../screens/AutoFulfillmentDetails'));
const ManualFulfillmentDetailsScreen = lazy(() => import('../../screens/ManualFulfillmentDetailsScreen'));
const LicenseProviderDefinitionDetails = lazy(() => import('../../screens/LicenseProviderDefinitionDetails'));
const FulfillmentPackagesScreen = lazy(() => import('../../screens/FulfillmentPackagesScreen'));
const CatalogsDetailsScreen = lazy(() => import('../../screens/CatalogsDetailsScreen'));
const CatalogsScreen = lazy(() => import('../../screens/CatalogsScreen'));
const CustomFieldDefinitionsScreen = lazy(() => import('../../screens/CustomFieldsDefinitionScreen'));
const CustomFieldDefinitionsDetailsScreen = lazy(() => import('../../screens/CustomFieldsDefinitionDetailsScreen'));
const StoreDetailsScreen = lazy(() => import('../../screens/StoreDetailsScreen'));
const StoresScreen = lazy(() => import('../../screens/StoresScreen'));
const OrderDetailsScreen = lazy(() => import('../../screens/OrderDetailsScreen'));
const OrdersScreen = lazy(() => import('../../screens/OrdersScreen'));
const MarketplaceOrdersScreen = lazy(() => import('../../screens/MarketplaceOrdersScreen'));
const MarketplaceOrdersDetailsScreen = lazy(() => import('../../screens/MarketplaceOrdersScreen/components/DetailsScreen'));
const InvoicesExportScreen = lazy(() => import('../../screens/InvoicesExportScreen'));
const SubscriptionDetailsScreen = lazy(() => import('../../screens/SubscriptionDetailsScreen'));
const SubscriptionsScreen = lazy(() => import('../../screens/SubscriptionsScreen'));
const MyAccountScreen = lazy(() => import('../../screens/MyAccountScreen'));
const LicenseDetailsScreen = lazy(() => import('../../screens/LicenseDetailsScreen'));
const LicensesScreen = lazy(() => import('../../screens/LicensesScreen/LicensesScreen'));
const IdentityDetailsScreen = lazy(() => import('../../screens/IdentityDetailsScreen'));
const IdentitiesScreen = lazy(() => import('../../screens/IdentitiesScreen'));
const NotificationHistoryDetailsScreen = lazy(() => import('../../screens/NotificationHistoryDetailsScreen'));
const NotificationDefinitionDetailsScreen = lazy(() => import('../../screens/NotificationDefinitionDetailsScreen'));
const NotificationDetailScreen = lazy(() => import('../../screens/NotificationDetailScreen'));
const CustomerDetailScreen = lazy(() => import('../../screens/CustomerDetailScreen'));
const CustomersScreen = lazy(() => import('../../screens/CustomersScreen'));
const MetaRoleDetailScreen = lazy(() => import('../../screens/AdministrationDetailsScreens/MetaRoleDetailScreen'));
const RoleDetailScreen = lazy(() => import('../../screens/AdministrationDetailsScreens/RoleDetailScreen'));
const PrivilegesDetailScreen = lazy(() => import('../../screens/AdministrationDetailsScreens/PrivilegesDetailScreen'));
const AdministrationScreen = lazy(() => import('../../screens/AdministrationScreen'));
const EmailBuilderDetailsScreen = lazy(() => import('../../screens/EmailBuilderDetailsScreen'));
const EmailBuilderScreen = lazy(() => import('../../screens/EmailBuilderScreen'));
const EndUserDetailScreen = lazy(() => import('../../screens/EndUserDetailScreen'));
const ResellerScreen = lazy(() => import('../../screens/ResellerScreen'));
const AddCart = lazy(() => import('../../screens/CartDetailsScreen/AddCart'));
const CartDetailsScreen = lazy(() => import('../../screens/CartDetailsScreen'));
const CartsScreen = lazy(() => import('../../screens/CartsScreen'));
const EndUsersGroupsDetailsScreen = lazy(() => import('../../screens/EndUsersGroupsDetailsScreen'));
const EndUsersGroupsScreen = lazy(() => import('../../screens/EndUsersGroupsScreen'));
const NotificationScreen = lazy(() => import('../../screens/NotificationScreen'));
const DiscountDetailsScreen = lazy(() => import('../../screens/DiscountDetailsScreen'));
const DiscountsScreen = lazy(() => import('../../screens/DiscountsScreen'));
const ImportExportPricesScreen = lazy(() => import('../../screens/ImportExportPricesScreen'));
const OrdersExportScreen = lazy(() => import('../../screens/OrdersExportScreen'));
const OrderCancellations = lazy(() => import('../../screens/OrderCancellationsScreen'));
const RecoDetailsScreen = lazy(() => import('../../screens/RecoDetailsScreen'));
const RecommendationScreen = lazy(() => import('../../screens/RecommendationScreen'));
const AbandonedCartDetailScreen = lazy(() => import('../../screens/AbandonedCartDetailScreen'));
const LicenseExpirationCampaignsDetailScreen = lazy(() => import('../../screens/LicenseExpirationCampaignsDetailScreen'));
const CampaignDetailsScreen = lazy(() => import('../../screens/CampaignDetailsScreen'));
const MarketingScreen = lazy(() => import('../../screens/MarketingScreen'));
const PricesDetailsScreen = lazy(() => import('../../screens/PricesDetailsScreen'));
const PriceFunctionDetailScreen = lazy(() => import('../../screens/PriceFunctionDetailScreen'));
const PriceModelsScreen = lazy(() => import('../../screens/PriceModelsScreen'));
const ThemeDetailsScreen = lazy(() => import('../../screens/ThemeDetailsScreen'));
const LayoutDetailsScreen = lazy(() => import('../../screens/LayoutDetailsScreen'));
const FontDetailsScreen = lazy(() => import('../../screens/FontDetailsScreen'));
const MarkupDetailsScreen = lazy(() => import('../../screens/MarkupDetailsScreen'));
const CheckoutExperienceScreen = lazy(() => import('../../screens/CheckoutExperienceScreen'));
const TranslationDetailScreen = lazy(() => import('../../screens/TranslationDetailScreen'));
const InvoiceTranslationsDetailScreen = lazy(() => import('../../screens/InvoiceTranslationsDetailScreen'));
const LocalizationScreen = lazy(() => import('../../screens/LocalizationScreen'));
const EndUsersScreen = lazy(() => import('../../screens/EndUsersScreen'));
const AuditDetailsScreen = lazy(() => import('../../screens/AuditDetailsScreen'));
const OnboardingDetailsScreen = lazy(() => import('../../screens/OnboardingDetailsScreen'));
const OnboardingScreen = lazy(() => import('../../screens/OnboardingScreen'));
const InvoicesCreditNotesScreen = lazy(() => import('../../screens/InvoicesCreditNotesScreen'));
const RemittablesScreen = lazy(() => import('../../screens/RemittablesScreen'));
const AuditsScreen = lazy(() => import('../../screens/AuditsScreen'));
const AuthenticationRealmDetailsScreen = lazy(() => import('../../screens/AuthenticationRealmDetailsScreen'));
const AuthenticationRealmsScreen = lazy(() => import('../../screens/AuthenticationRealmsScreen'));
const SubsidiaryDetailScreen = lazy(() => import('../../screens/SubsidiaryDetailScreen'));
const SubsidiaryManagerScreen = lazy(() => import('../../screens/SubsidiaryManagerScreen'));
const CurrencyDetailScreen = lazy(() => import('../../screens/CurrencyDetailScreen'));
const LocaleDetailScreen = lazy(() => import('../../screens/LocaleDetailScreen'));
const CountryDetailScreen = lazy(() => import('../../screens/CountryDetailScreen'));
const ReferentialsScreen = lazy(() => import('../../screens/ReferentialsScreen'));
const TncScreen = lazy(() => import('../../screens/TncScreen'));
const TncSectionView = lazy(() => import('../../screens/TncScreen/components/TncSectionDetailView'));
const CrudHelperScreen = lazy(() => import('../../screens/CrudHelperScreen'));
const CrudHelperRequestScreen = lazy(() => import('../../screens/CrudHelperRequestScreen'));
const ExportManagementScreen = lazy(() => import('../../screens/ExportManagementScreen'));
const SubscriptionMonitoring = lazy(() => import('../../screens/SubscriptionMonitoring'));

const SignedRoutes = () => (
  <Switch>
    <Route
      path={parentPaths.default}
      exact
      component={DashboardScreen}
    />
    <Route
      path={`${parentPaths.productlist}/:id`}
        // key props is a hack that create new instance for each ID
      render={({ match: { params } }) => <ProductDetailsScreen key={params.id} id={params.id} />}
    />
    <Route
      path={`${parentPaths.productlist}`}
      component={ProductsScreen}
    />
    <Route
      path={`${parentPaths.fulfillment.autoFulfillmentsTab}/:id`}
      component={AutoFulfillmentDetails}
    />
    <Route
      path={`${parentPaths.fulfillment.manualFulfillmentsTab}/:id`}
      component={ManualFulfillmentDetailsScreen}
    />
    <Route
      path={`${parentPaths.fulfillment.licenseProviderDefinitionsTab}/:id`}
      component={LicenseProviderDefinitionDetails}
    />
    <Route
      path={`${parentPaths.fulfillment.main}`}
      component={FulfillmentPackagesScreen}
    />
    <Route
      path={`${parentPaths.catalogs}/:id`}
      component={CatalogsDetailsScreen}
    />
    <Route
      path={`${parentPaths.catalogs}`}
      component={CatalogsScreen}
    />
    <Route
      path={`${parentPaths.customFieldsDefinition}/:id`}
      component={CustomFieldDefinitionsDetailsScreen}
    />
    <Route
      path={`${parentPaths.customFieldsDefinition}`}
      component={CustomFieldDefinitionsScreen}
    />
    <Route
      path={`${parentPaths.exportManagement.subscriptions}`}
      component={ExportManagementScreen}
    />
    <Route
      path={`${parentPaths.exportManagement.products}`}
      component={ExportManagementScreen}
    />
    <Route
      path={`${parentPaths.exportManagement.discountRules}`}
      component={ExportManagementScreen}
    />
    <Route
      path={`${parentPaths.exportManagement.main}`}
      component={ExportManagementScreen}
    />

    <Route
      path={`${parentPaths.stores}/:id`}
      component={StoreDetailsScreen}
    />
    <Route
      path={`${parentPaths.stores}`}
      component={StoresScreen}
    />
    <Route
      path={`${parentPaths.orderlist}/:id`}
      component={OrderDetailsScreen}
    />
    <Route
      path={`${parentPaths.orderlist}`}
      component={OrdersScreen}
    />
    <Route
      path={`${parentPaths.ordersExport.main}`}
      component={OrdersExportScreen}
    />
    <Route
      path={`${parentPaths.ordersExport.list}`}
      component={OrdersExportScreen}
    />
    <Route
      path={`${parentPaths.ordersExport.search}`}
      component={OrdersExportScreen}
    />
     <Route
      path={`${parentPaths.orderCancellations}`}
      component={OrderCancellations}
    />
    <Route
      path={`${parentPaths.marketplaceOrders}/:id`}
      component={MarketplaceOrdersDetailsScreen}
    />
    <Route
      path={`${parentPaths.marketplaceOrders}`}
      component={MarketplaceOrdersScreen}
    />
    <Route
      path={`${parentPaths.invoicesExport}`}
      component={InvoicesExportScreen}
    />
    <Route
      path={`${parentPaths.subscriptions}/:id`}
      component={SubscriptionDetailsScreen}
    />
    <Route
      path={`${parentPaths.subscriptions}`}
      component={SubscriptionsScreen}
    />
    <Route
      path={`${parentPaths.myaccount}`}
      component={MyAccountScreen}
    />
    <Route
      path={`${parentPaths.licenses}/:id`}
      component={LicenseDetailsScreen}
    />
    <Route
      path={`${parentPaths.licenses}`}
      component={LicensesScreen}
    />
    <Route
      path={`${parentPaths.users}/:id`}
      component={IdentityDetailsScreen}
    />
    <Route
      path={`${parentPaths.users}`}
      component={IdentitiesScreen}
    />
    <Route
      path={`${parentPaths.notifications.notificationHistoryTab}/:id`}
      component={NotificationHistoryDetailsScreen}
    />
    <Route
      path={`${parentPaths.notifications.notificationDefinitionTab}/:id`}
      component={NotificationDefinitionDetailsScreen}
    />
    <Route
      path={`${parentPaths.notifications.notificationReceiversTab}/:id`}
      component={NotificationDetailScreen}
    />
    <Route
      path={`${parentPaths.customers}/:id`}
      component={CustomerDetailScreen}
    />
    <Route
      path={`${parentPaths.customers}`}
      component={CustomersScreen}
    />
    <Route
      path={`${parentPaths.userroles.profiles}/:id`}
      component={MetaRoleDetailScreen}
    />
    <Route
      path={`${parentPaths.userroles.roles}/:id`}
      component={RoleDetailScreen}
    />
    <Route
      path={`${parentPaths.userroles.privileges}/:id`}
      component={PrivilegesDetailScreen}
    />
    <Route
      path={`${parentPaths.userroles.main}`}
      component={AdministrationScreen}
    />
    <Route
      path={`${parentPaths.emailbuilder}/:id`}
      component={EmailBuilderDetailsScreen}
    />
    <Route
      path={`${parentPaths.emailbuilder}`}
      component={EmailBuilderScreen}
    />
    <Route
      path={`${parentPaths.endusers}/:id`}
      component={EndUserDetailScreen}
    />
    <Route
      path={`${parentPaths.resellers}/:id`}
      component={EndUserDetailScreen}
    />
    <Route
      path={`${parentPaths.resellers}`}
      component={ResellerScreen}
    />
    <Route
      path={`${parentPaths.carts}/add`}
      component={AddCart}
    />
    <Route
      path={`${parentPaths.carts}/:id`}
      component={CartDetailsScreen}
    />
    <Route
      path={`${parentPaths.carts}`}
      component={CartsScreen}
    />
    <Route
      path={`${parentPaths.endusergroups}/:id`}
      component={EndUsersGroupsDetailsScreen}
    />
    <Route
      path={`${parentPaths.endusergroups}`}
      component={EndUsersGroupsScreen}
    />
    <Route
      path={`${parentPaths.notifications.main}`}
      component={NotificationScreen}
    />
    <Route
      path={`${parentPaths.discountrules}/:id`}
      component={DiscountDetailsScreen}
    />
    <Route
      path={`${parentPaths.discountrules}`}
      component={DiscountsScreen}
    />
    <Route
      path={`${parentPaths.importExportPrices}`}
      component={ImportExportPricesScreen}
    />
    <Route
      path={`${parentPaths.recommendations}/:id`}
      component={RecoDetailsScreen}
    />
    <Route
      path={`${parentPaths.recommendations}`}
      component={RecommendationScreen}
    />
    <Route
      path={`${parentPaths.campaigns.abandoned}/:id`}
      component={AbandonedCartDetailScreen}
    />
    <Route
      path={`${parentPaths.campaigns.campaigns}/:id`}
      component={CampaignDetailsScreen}
    />
    <Route
      path={`${parentPaths.campaigns.licenseExpiration}/:id`}
      component={LicenseExpirationCampaignsDetailScreen}
    />
    <Route
      path={`${parentPaths.campaigns.main}`}
      component={MarketingScreen}
    />
    <Route
      path={`${parentPaths.pricemodels.pricesTab}/:id`}
      component={PricesDetailsScreen}
    />
    <Route
      path={`${parentPaths.pricemodels.pricefunctionsTab}/:id`}
      component={PriceFunctionDetailScreen}
    />
    <Route
      path={`${parentPaths.pricemodels.main}`}
      component={PriceModelsScreen}
    />
    <Route
      path={`${parentPaths.checkoutpagebuilder.themesTab}/:id`}
      component={ThemeDetailsScreen}
    />
    <Route
      path={`${parentPaths.checkoutpagebuilder.layoutsTab}/:id`}
      component={LayoutDetailsScreen}
    />
    <Route
      path={`${parentPaths.checkoutpagebuilder.fontsTab}/:id`}
      component={FontDetailsScreen}
    />
    <Route
      path={`${parentPaths.checkoutpagebuilder.markupsTab}/:id`}
      component={MarkupDetailsScreen}
    />
    <Route
      path={`${parentPaths.checkoutpagebuilder.main}`}
      component={CheckoutExperienceScreen}
    />
    <Route
      path={`${parentPaths.localization.translationsTab}/:id`}
      component={TranslationDetailScreen}
    />
    <Route
      path={`${parentPaths.localization.invoiceTranslationsTab}/:id`}
      component={InvoiceTranslationsDetailScreen}
    />
    <Route
      path={`${parentPaths.localization.main}`}
      component={LocalizationScreen}
    />
    <Route
      path={`${parentPaths.endusers}`}
      component={EndUsersScreen}
    />
    <Route
      path={`${parentPaths.audits}/:id`}
      component={AuditDetailsScreen}
    />
    <Route
      path={`${parentPaths.onboarding}/:id`}
      component={OnboardingDetailsScreen}
    />
    <Route
      path={`${parentPaths.onboarding}`}
      component={OnboardingScreen}
    />
    <Route
      path={`${parentPaths.invoices}`}
      component={InvoicesCreditNotesScreen}
    />
    <Route
      path={`${parentPaths.subscriptionMonitoring}`}
      component={SubscriptionMonitoring}
    />
    <Route
      path={`${parentPaths.remittables}`}
      component={RemittablesScreen}
    />
    <Route
      path={`${parentPaths.audits}`}
      component={AuditsScreen}
    />
    <Route
      path={`${parentPaths.realms}/:id`}
      component={AuthenticationRealmDetailsScreen}
    />
    <Route
      path={`${parentPaths.realms}`}
      component={AuthenticationRealmsScreen}
    />
    <Route
      path={`${parentPaths.subsidiaryManager.subsidiariesTab}/:id`}
      component={SubsidiaryDetailScreen}
    />
    <Route
      path={`${parentPaths.subsidiaryManager.main}`}
      component={SubsidiaryManagerScreen}
    />

    <Route
      path={`${parentPaths.referentialManager.currenciesTab}/:id`}
      component={CurrencyDetailScreen}
    />
    <Route
      path={`${parentPaths.referentialManager.localesTab}/:id`}
      component={LocaleDetailScreen}
    />
    <Route
      path={`${parentPaths.referentialManager.countriesTab}/:id`}
      component={CountryDetailScreen}
    />
    <Route
      path={`${parentPaths.referentialManager.main}`}
      component={ReferentialsScreen}
    />
    <Route
      path={`${parentPaths.tncManager.archived}/:id`}
      component={TncSectionView}
    />
    <Route
      path={`${parentPaths.tncManager.draft}/:id`}
      component={TncSectionView}
    />
    <Route
      path={`${parentPaths.tncManager.running}/:id`}
      component={TncSectionView}
    />
    <Route
      path={`${parentPaths.tncManager.main}`}
      component={TncScreen}
    />
    <Route
      path={`${parentPaths.crudHelper.main}`}
      exact
      component={CrudHelperScreen}
    />
    <Route
      path={`${parentPaths.crudHelper.request}`}
      exact
      component={CrudHelperRequestScreen}
    />

    <Redirect to={parentPaths.default} />
  </Switch>
);

export default SignedRoutes;
